(function () {
	if (window.NativaLightbox) return;

	const overlay = document.createElement('div');
	overlay.className = 'nativa-lightbox-overlay';
	overlay.innerHTML = `
		<button class="close">×</button>
		<button class="prev"><</button>
		<img />
		<button class="next">></button>
	`;

	document.body.appendChild(overlay);

	const imgEl = overlay.querySelector('img');
	const prevBtn = overlay.querySelector('.prev');
	const nextBtn = overlay.querySelector('.next');
	const closeBtn = overlay.querySelector('.close');

	let images = [];
	let current = 0;

	function update() {
		imgEl.src = images[current].url;
		imgEl.alt = images[current].alt || '';
	}

	function updateControls() {
		const hasMultiple = images.length > 1;

		prevBtn.classList.toggle('is-hidden', !hasMultiple);
		nextBtn.classList.toggle('is-hidden', !hasMultiple);
	}

	function open({ images: imgs, startIndex = 0 }) {
		images = imgs;
		current = startIndex;

		update();
		updateControls();

		overlay.classList.add('is-open');
		document.body.style.overflow = 'hidden';
	}

	function close() {
		overlay.classList.remove('is-open');
		document.body.style.overflow = '';
	}

	prevBtn.addEventListener('click', (e) => {
		e.stopPropagation();
		if (images.length <= 1) return;

		current = (current - 1 + images.length) % images.length;
		update();
	});

	nextBtn.addEventListener('click', (e) => {
		e.stopPropagation();
		if (images.length <= 1) return;

		current = (current + 1) % images.length;
		update();
	});

	closeBtn.addEventListener('click', close);

	overlay.addEventListener('click', (e) => {
		if (e.target === overlay) close();
	});

	document.addEventListener('keydown', (e) => {
		if (!overlay.classList.contains('is-open')) return;

		if (e.key === 'Escape') close();

		if (images.length > 1) {
			if (e.key === 'ArrowRight') nextBtn.click();
			if (e.key === 'ArrowLeft') prevBtn.click();
		}
	});

	window.NativaLightbox = { open };

	// INIT gallery triggers
	document.addEventListener('DOMContentLoaded', () => {
		const galleries = document.querySelectorAll('.nativa-gallery-lightbox');

		galleries.forEach((block) => {
			const imgs = block.querySelectorAll('img');
			const data = JSON.parse(block.dataset.images || '[]');

			imgs.forEach((img, index) => {
				img.addEventListener('click', () => {
					open({
						images: data,
						startIndex: index,
					});
				});
			});
		});
	});
})();
